export default "__VITE_ASSET__Bk2u_dJZ__"